import React from "react";
import "./SafetyCommitment.css";
import SectionTitle from "../../common/common_title/SectionTitle";
export default function SafetyCommitment() {
  return (
    <div className="SafetyCommitment-section ">
      <div className="container">
        <div className="heading-wrapper">
          {" "}
          <SectionTitle
            title="Safety and Commitment"
            subtitle="Safety Is Our Priority  "
            className="h-title"
          />
        </div>
        <div className="wrapper-div ">
          <div className="left col-7">
            <p className="desc">
              We operate with strict safety protocols & industry best practices
              to ensure every effect is executed responsibly. Our team is
              trained, certified, & committed to delivering spectacular results
              without compromise. We operate with strict safety protocols &
              industry best practices to ensure every effect is executed
              responsibly. Our team is trained, certified, & committed to
              delivering spectacular results without compromise. We operate with
              strict safety protocols & industry best practices to ensure every
              effect is executed responsibly. Our team is trained, certified, &
              committed to delivering spectacular results without compromise. We
              operate with strict safety protocols & industry best practices to
              ensure every effect is executed responsibly. Our team is trained,
              certified, & committed to delivering spectacular results without
              compromise.
            </p>
          </div>
          <div className="right col-5">
            <img src="/assets/images/newhome/saftyimg.jpg" />
          </div>
        </div>
      </div>
    </div>
  );
}
